import React, { useState } from "react";
import { Ratio } from "components/forms/FormFields/PictureGallery/helpers";
import strings from "localisation/strings";
import InlineInputGroup from "components/forms/FormFields/InlineInputGroup";
import OverlaySpinner from "components/generic/OverlaySpinner";
import VideoAutoDragAndDrop from "components/forms/FormFields/VideoAutoDragAndDrop";
import APIErrorResponse from "common/api/models/APIErrorResponse";

interface VideoDragAndDropProps {
  showVideoPicker: boolean;
  ratio?: Ratio;
  videoUrl?: string | null;
  setVideoUrl?: (videoUrl: string | null) => void;
  videosErrors?: string[];
  parseErrors?: (response: APIErrorResponse) => void;
}

const VIDEO_CONTAINER = "VIDEOS";

const VideoDragAndDrop = ({
  showVideoPicker,
  ratio = Ratio.ratio9_16,
  videoUrl,
  setVideoUrl,
  videosErrors,
  parseErrors,
}: VideoDragAndDropProps) => {
  const [showOverlay, setShowOverlay] = useState<boolean>(false);

  if (!showVideoPicker) {
    return null;
  }

  return (
    <InlineInputGroup
      labelMargin="0px 0px 0px 5px"
      placeholder={strings("glassUi.video.placeholder")}
      wrapText
    >
      <VideoAutoDragAndDrop
        placeholder={strings(`videoDragAndDrop.dropHere`)}
        fileUrl={videoUrl}
        setFileUrl={setVideoUrl}
        container={VIDEO_CONTAINER}
        parseErrors={parseErrors}
        setWaitingStatus={setShowOverlay}
        hasFormErrors={videosErrors && videosErrors.length > 0}
        fixedRatio
        withCropAndZoom={false}
        ratio={ratio}
        fileMaxSize={200}
        width="70%"
      />
      {showOverlay && <OverlaySpinner />}
    </InlineInputGroup>
  );
};

export default VideoDragAndDrop;
